import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { TASK_CATEGORY_API } from "../apiRoutes";

interface UseGetTaskCategoriesByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTaskCategoriesById = async (id: string) => {
  return await axiosAuth.get(`${TASK_CATEGORY_API}/${id}`);
};

const useGetTaskCategoriesById = ({
  id,
  queryParams,
}: UseGetTaskCategoriesByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["tak-categories", id],
    queryFn: () => getTaskCategoriesById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTaskCategoriesById;
